import { Box, Chip, Input, MenuItem, Select, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { CustomDataGrid } from '../../../common/components/Table/CustomDataGrid';
// eslint-disable-next-line no-unused-vars
import { v4 } from "uuid";
import { sample_types as old_sample_types } from '../../HomePage/components/PoTable/helper/po_columns';
import HomePageTimeDatePicker from '../../HomePage/components/HomePageTimeDatePicker';
import httpCommon from '../../../http-common';
import ContainedButton from '../../../common/components/Buttons/ContainedButton';
import ReportingDialog from './ReportingDialog';
import { get_material_types_list } from '../utils/helpers';
import ApprovalDropdown from './ApprovalDropdown';

const postNewScheduleItem = async (sample_status_data) => {
  console.log(sample_status_data);
  const dd_qcrd = sample_status_data.qc_receive_date.getDate();
  const mm_qcrd = sample_status_data.qc_receive_date.getMonth();
  const yyyy_qcrd = sample_status_data.qc_receive_date.getFullYear();
  const hh_qcrd = sample_status_data.qc_receive_date.getHours();
  const min_qcrd = sample_status_data.qc_receive_date.getMinutes();
  const ss_qcrd = sample_status_data.qc_receive_date.getSeconds();

  const d_qcrd = `${yyyy_qcrd}-${mm_qcrd + 1}-${dd_qcrd} ${hh_qcrd}:${min_qcrd}:${ss_qcrd}`;
  sample_status_data.qc_receive_date = d_qcrd;

  const dd_pst = sample_status_data.pre_start_time.getDate();
  const mm_pst = sample_status_data.pre_start_time.getMonth();
  const yyyy_pst = sample_status_data.pre_start_time.getFullYear();
  const hh_pst = sample_status_data.pre_start_time.getHours();
  const min_pst = sample_status_data.pre_start_time.getMinutes();
  const ss_pst = sample_status_data.pre_start_time.getSeconds();

  const d_pst = `${yyyy_pst}-${mm_pst + 1}-${dd_pst} ${hh_pst}:${min_pst}:${ss_pst}`;
  sample_status_data.analyst_start_time = d_pst;

  const dd_pet = sample_status_data.pre_end_time.getDate();
  const mm_pet = sample_status_data.pre_end_time.getMonth();
  const yyyy_pet = sample_status_data.pre_end_time.getFullYear();
  const hh_pet = sample_status_data.pre_end_time.getHours();
  const min_pet = sample_status_data.pre_end_time.getMinutes();
  const ss_pet = sample_status_data.pre_end_time.getSeconds();

  const d_pet = `${yyyy_pet}-${mm_pet + 1}-${dd_pet} ${hh_pet}:${min_pet}:${ss_pet}`;
  sample_status_data.analyst_end_time = d_pet;
  delete sample_status_data.pre_start_time;
  delete sample_status_data.pre_end_time;

  const dd_mst = sample_status_data.machine_start_time.getDate();
  const mm_mst = sample_status_data.machine_start_time.getMonth();
  const yyyy_mst = sample_status_data.machine_start_time.getFullYear();
  const hh_mst = sample_status_data.machine_start_time.getHours();
  const min_mst = sample_status_data.machine_start_time.getMinutes();
  const ss_mst = sample_status_data.machine_start_time.getSeconds();

  const d_mst = `${yyyy_mst}-${mm_mst + 1}-${dd_mst} ${hh_mst}:${min_mst}:${ss_mst}`;
  delete sample_status_data.machine_start_time;
  sample_status_data.machine_start_time = d_mst;

  const dd_met = sample_status_data.machine_end_time.getDate();
  const mm_met = sample_status_data.machine_end_time.getMonth();
  const yyyy_met = sample_status_data.machine_end_time.getFullYear();
  const hh_met = sample_status_data.machine_end_time.getHours();
  const min_met = sample_status_data.machine_end_time.getMinutes();
  const ss_met = sample_status_data.machine_end_time.getSeconds();

  const d_met = `${yyyy_met}-${mm_met + 1}-${dd_met} ${hh_met}:${min_met}:${ss_met}`;
  delete sample_status_data.machine_end_time;
  sample_status_data.machine_end_time = d_met;

  // return {
  //   status: "success"
  // };
  const id = sample_status_data.id;
  delete sample_status_data?.id;
  const data = JSON.stringify({ ...sample_status_data });
  try {
    const response = await httpCommon.post(`/v1/qc/edit_qc_schedule/`, data);
    const result = response.data;
    if (result?.status === "success") {
      alert("Added Schedule Successfully!");
      sample_status_data.id = id;
      return true;
    }
    else throw new Error(`${result.message}`);
  } catch (error) {
    console.log({ error });
    return error;
    // return ;
  }
};

const ScheduleFieldCell = ({ value, id, handle_change, type = "text", options = [] }) => {
  if (type === "select") {
    return <Box className="w-full">
      <Select sx={{ width: "100%" }} value={value} id={id} onChange={handle_change} name={id} size='small' >
        <MenuItem value="" disabled key={"nothing_in_schedule_material_type"}>Select Material Type</MenuItem>
        {
          options?.map((item, idx) => <MenuItem key={`${item.label}-${idx}`} value={item?.value} >{item?.label}</MenuItem>)
        }
      </Select>
    </Box>;
  }
  return <Input
    // sx={{ width: "100%" }}
    value={value}
    id={id}
    name={id}
    onChange={(e) => {
      handle_change(e);
    }}
    onKeyDown={(e) => {
      e.stopPropagation();
    }}
    type={type} />;
};

const ScheduleComponent = ({
  schedule,
  columns,
  initialState = { pinnedColumns: { left: ["batch_number", "batch_no", "material_name", "product_name"], right: ["analyst_id", "machine_id", 'status', "remark"], } },
  title,
  empty_message = "No Schedule Found",
  show_count = false,
  height = 300,
  has_new_schedule_row = false,
  hidden_fields = [],
  gridApiRef,
  editRowStatus,
  scheduleStatus,
  edit_enabled,
  aria_label
}) => {
  // console.log(title, scheduleStatus);
  // const gridApiRef = useGridApiRef();
  const updateEditableStatusColumn = (columns, edit, aria_label, scheduleStatus) => {
    let updatedColumns = columns.map((column) => {
      if (column.field === "status") {
        return {
          ...column,
          editable: edit,
        };
      } else {
        return {
          ...column,
          renderCell:
            aria_label === "ongoing_table" ||
              aria_label === "adhoc_table" ||
              (scheduleStatus && scheduleStatus === "approved")
              ? null
              : column.renderCell,
        };
      }
    });

    // Add an extra column for "adhoc" aria_label
    if (aria_label === "adhoc_table") {
      const approval = {
        field: "approval",
        headerName: "Approval Status",
        visible: true,
        editable: false,
        width: 150,
        renderCell: (props) =>
          <ApprovalDropdown {...props} />
        ,
      };
      updatedColumns = [...updatedColumns, approval];
    }
    // console.log(updatedColumns);
    return updatedColumns;
  };

  // console.log(title, updateEditableStatusColumn(columns, editRowStatus, title, scheduleStatus));
  const [selected_row, set_selected_row] = useState({});

  gridApiRef.current.set_selected_row = set_selected_row;

  const getRowClassName = (params) => {
    // console.log(params.row);
    if (params.row.status === "Completed") {
      return 'bg-green-200 hover:bg-green-300'; // Apply this class for completed rows
    }
    if (params.row.approve === false && (aria_label === "today_table" || aria_label === "upcoming_table")) {
      return "bg-yellow-200"; // Apply this class for completed rows
    }
    return '';
  };

  const [new_dg_row, set_new_dg_row] = useState([{
    "id": v4(),
    "product_code": "",
    "product_name": "",
    "batch_number": "",
    "qc_receive_date": new Date(),
    "market": "",
    "material_type": "",
    "spec_id": "",
    "stp_id": "",
    "test_name": "",
    "non_critical_machines": "",
    "pre_start_time": new Date(),
    "pre_end_time": new Date(),
    "analyst_id": "",
    "machine_id": "",
    "machine_start_time": new Date(),
    "machine_end_time": new Date(),
  }]);

  const handle_change_new_row_data = (e) => {
    const { id, value, name } = e.target;
    // console.log({ id, value, e, name });
    const old = { ...new_dg_row[0] };
    old[id || name] = value;
    set_new_dg_row([{ ...old }]);
  };

  const [sample_types, set_sample_types] = useState([...old_sample_types]);

  const initialise_sample_types = async () => {
    const names_list = await get_material_types_list();
    if (names_list) {
      const sample_types_arr = names_list?.map(name => ({
        value: name,
        label: name
      }));
      set_sample_types(sample_types_arr);
    }
  };

  useEffect(() => {
    initialise_sample_types();
  }, []);

  const new_dg_columns = [
    {
      field: "_id",
      headerName: "ID",
      visible: false,
      width: 100,
    },
    {
      field: "product_code",
      headerName: "Product Code",
      visible: true,
      editable: false,
      width: 150,
      renderCell: (props) => {
        return <ScheduleFieldCell {...props} value={new_dg_row[0]["product_code"]}
          handle_change={handle_change_new_row_data}
          id={"product_code"}
        />;
      },
    },
    {
      field: "product_name",
      headerName: "Product Name",
      visible: true,
      editable: false,
      width: 150,
      renderCell: (props) => {
        return <ScheduleFieldCell {...props} value={new_dg_row[0]["product_name"]}
          handle_change={handle_change_new_row_data}
          id={"product_name"}
        />;
      },
    },
    {
      field: "test_name",
      headerName: "TEST NAME",
      visible: true,
      editable: false,
      width: 150,
      renderCell: (props) => {
        return <ScheduleFieldCell {...props} value={new_dg_row[0]["test_name"]}
          handle_change={handle_change_new_row_data}
          id={"test_name"}
        />;
      },
    },
    {
      field: "spec_id",
      headerName: "SPEC ID",
      visible: true,
      editable: false,
      width: 150,
      renderCell: (props) => {
        return <ScheduleFieldCell {...props} value={new_dg_row[0]["spec_id"]}
          handle_change={handle_change_new_row_data}
          id={"spec_id"}
        />;
      },
      // type: "singleSelect",
      // valueOptions: [
      //   { label: "FS015148", value: "FS015148" },
      //   { label: "FS007772", value: "FS007772" },
      //   { label: "FS007940", value: "FS007940" },
      //   { label: "FS011879", value: "FS011879" },
      //   { label: "FS012696", value: "FS012696" },
      //   { label: "FS017600", value: "FS017600" },
      //   { label: "FS015148", value: "FS015148" },
      //   { label: "FS007940", value: "FS007940" },
      //   { label: "FS007772", value: "FS007772" },
      //   { label: "FS011879", value: "FS011879" },
      //   { label: "FS012696", value: "FS012696" },
      //   { label: "FS017600", value: "FS017600" },
      // ]
    },
    {
      field: "qc_receive_date",
      headerName: "QC RECEIVE DATE",
      visible: true,
      editable: false,
      width: 210,
      type: "dateTime",
      renderCell: (props) => {
        return <HomePageTimeDatePicker {...props} state_setter={set_new_dg_row} />;
      }
    },
    {
      field: "market",
      headerName: "MARKET",
      visible: true,
      editable: false,
      width: 150,
      renderCell: (props) => {
        return <ScheduleFieldCell {...props} value={new_dg_row[0]["market"]}
          handle_change={handle_change_new_row_data}
          id={"market"}
        />;
      },
    },
    {
      field: "material_type",
      headerName: "MATERIAL TYPE",
      visible: true,
      editable: false,
      width: 200,
      type: "singleSelect",
      valueOptions: [
        ...sample_types
      ],
      renderCell: (props) => {
        return <ScheduleFieldCell {...props} value={new_dg_row[0]["material_type"]}
          handle_change={handle_change_new_row_data}
          id={"material_type"}
          type={'select'}
          options={[...sample_types]}
        />;
      },
    },
    {
      field: "analyst_id",
      headerName: "ANALYST ID",
      visible: true,
      editable: false,
      width: 200,
      renderCell: (props) => {
        return <ScheduleFieldCell {...props} value={new_dg_row[0]["analyst_id"]}
          handle_change={handle_change_new_row_data}
          id={"analyst_id"}
        />;
      },
      // renderCell: (props) => <AnalystDropdown {...props} />,
    },
    {
      field: "machine_id",
      headerName: "MACHINE ID",
      visible: true,
      editable: false,
      width: 100,
      renderCell: (props) => {
        return <ScheduleFieldCell {...props} value={new_dg_row[0]["machine_id"]}
          handle_change={handle_change_new_row_data}
          id={"machine_id"}
        />;
      },
      // renderCell: (props) => <MachineDropdown {...props} />,
      // type: "singleSelect",
      // valueOptions: [...machine_list]
    },

    {
      field: "pre_start_time",
      headerName: "ANALYST START TIME",
      visible: true,
      width: 210,
      type: "dateTime",
      editable: false,
      valueGetter: ({ value }) => {
        return new Date(value);
      },
      renderCell: (props) => {
        return <HomePageTimeDatePicker {...props} state_setter={set_new_dg_row} />;
      },
    },
    {
      field: "pre_end_time",
      headerName: "ANALYST END TIME",
      visible: true,
      width: 210,
      type: "dateTime",
      editable: false,
      valueGetter: ({ value }) => {
        return new Date(value);
      },
      renderCell: (props) => {
        return <HomePageTimeDatePicker {...props} state_setter={set_new_dg_row} />;
      }
    },
    {
      field: "machine_start_time",
      headerName: "MACHINE START TIME",
      visible: true,
      width: 210,
      type: "dateTime",
      editable: false,
      valueGetter: ({ value }) => {
        return new Date(value);
      },
      renderCell: (props) => {
        return <HomePageTimeDatePicker {...props} state_setter={set_new_dg_row} />;
      }
    },
    {
      field: "machine_end_time",
      headerName: "MACHINE END TIME",
      visible: true,
      width: 210,
      type: "dateTime",
      editable: false,
      valueGetter: ({ value }) => {
        return new Date(value);
      },
      renderCell: (props) => {
        return <HomePageTimeDatePicker {...props} state_setter={set_new_dg_row} />;
      }
    },

    {
      field: "batch_number",
      headerName: "BATCH ID",
      visible: true,
      editable: false,
      width: 100,
      renderCell: (props) => {
        return <ScheduleFieldCell {...props} value={new_dg_row[0]["batch_number"]}
          handle_change={handle_change_new_row_data}
          id={"batch_number"}
        />;
      },
    },




    // {
    //   field: "stp_id",
    //   headerName: "STP ID",
    //   visible: true,
    //   editable: false,
    //   width: 150,
    //   renderCell: (props) => {
    //     return <ScheduleFieldCell {...props} value={new_dg_row[0]["stp_id"]}
    //       handle_change={handle_change_new_row_data}
    //       id={"stp_id"}
    //     />;
    //   },
    //   // type: "singleSelect",
    //   // valueOptions: [
    //   //   { label: "FT007296", value: "FT007296" },
    //   //   { label: "FT003572", value: "FT003572" },
    //   //   { label: "FT003702", value: "FT003702" },
    //   //   { label: "FT005640", value: "FT005640" },
    //   //   { label: "FT010562", value: "FT010562" },
    //   //   { label: "FT006061", value: "FT006061" },
    //   //   { label: "FT008844", value: "FT008844" },
    //   //   { label: "FT010888", value: "FT010888" },
    //   // ]
    // },

    // "step_name": {
    //   field: "step_name",
    //   headerName: "STEP NAME",
    //   visible: true,
    //   editable: false,
    //   width: 250,
    // },

    {
      field: "non_critical_machines",
      headerName: "NON CRITICAL MACHINES",
      visible: true,
      editable: false,
      width: 200,
      renderCell: (props) => {
        return <ScheduleFieldCell {...props} value={new_dg_row[0]["non_critical_machines"]}
          handle_change={handle_change_new_row_data}
          id={"non_critical_machines"}
        />;
      },
      // renderCell: (props) => <NonCriticalMachines {...props} />,
      // type: "singleSelect",
      // valueOptions: [...machine_list]
    },



    {
      "field": "add_row",
      "headerName": "",
      "editable": false,
      renderCell: () => {
        const handle_add = async () => {
          const row = new_dg_row[0];
          const { stp_id, ...rowWithoutStpId } = row; // to exclude stp_id
          const vals = Object.values(rowWithoutStpId);
          // const vals = Object.values(row);
          console.log(vals);
          for (let val of vals) {
            if (val === "" || val === null) {
              console.log({ val, row });
              alert("Please enter all the fields before adding the Sample Status.");
              return;
            }
          }

          const response = await postNewScheduleItem({ ...row });
          if (response === true) {
            gridApiRef.current.updateRows([{ ...row }]);
            set_new_dg_row(prev => ([{
              ...prev[0],
              "product_code": "",
              "product_name": "",
              "batch_number": "",
              "qc_receive_date": new Date(),
              "market": "",
              "material_type": "",
              "spec_id": "",
              "stp_id": "",
              "test_name": "",
              "non_critical_machines": "",
              "pre_start_time": new Date(),
              "pre_end_time": new Date(),
              "analyst_id": "",
              "machine_id": "",
              "machine_start_time": new Date(),
              "machine_end_time": new Date(),
              "id": v4(),
            }]));
            // alert("updated");
          }
          else {
            // alert("couldn't update due to some error at the backend.");
            alert(response);
          }
        };
        return <ContainedButton handleClick={handle_add}>Add</ContainedButton>;
      }
    }
  ];

  const [open, set_open] = useState(false);

  const handleClose = () => {
    set_open(false);
  };

  useEffect(() => {
    // console.log({ selected_row });
    if (Object.keys(selected_row).length > 0) {
      set_open(true);
    }
  }, [selected_row]);



  return (
    <Box className="my-4">
      {
        gridApiRef?.current?.selectedRow && <div>
          <ReportingDialog
            gridApiRef={gridApiRef}
            handleClose={handleClose}
            open={open}
            selected_row={selected_row}
          />
        </div>
      }
      <Box className="flex items-center gap-4 my-2">
        <Typography variant="h5" mb="0" gutterBottom align="left">
          {title}
        </Typography>
        {
          show_count &&
          <Chip label={`Total Tests : ${schedule.length}`} />
        }
      </Box>
      <Box sx={{ height, width: "100%" }}>
        <CustomDataGrid
          editMode={"row"}
          apiRef={gridApiRef}
          // columns={columns}
          aria-label={aria_label}
          columns={updateEditableStatusColumn(columns, editRowStatus, aria_label, scheduleStatus)}
          rows={schedule}
          processRowUpdate={(updatedRow, oldRow) => {
            console.log(updatedRow, oldRow);
            return true;
          }}
          // pagination
          // initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
          // pageSizeOptions={[10, 25, 50, 100]}
          hideFooter
          columnVisibilityModel={{
            id: false,
            _id: false,
            // stp_id: false,
            ...hidden_fields?.reduce((acc, el) => ({
              ...acc,
              [el]: false
            }), {})
          }}
          initialState={initialState}
          getRowClassName={getRowClassName}
          slots={{
            noRowsOverlay: () => <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}>
              <p className='text-lg'>No {title} Found</p>
            </div>
          }}
        />
      </Box>
      {
        has_new_schedule_row &&
        (
          <div>
            <h2 className="text-lg font-normal p-3">
              Add a New Task
            </h2>
            <Box>
              <CustomDataGrid
                columns={new_dg_columns}
                rows={new_dg_row}
                columnVisibilityModel={{
                  id: false,
                  _id: false,
                  // stp_id: false,
                }}
                initialState={{
                  pinnedColumns: {
                    left: ["batch_number", "batch_no", "material_name", "product_name"],
                    right: ["add_row"]
                  }
                }}
                hideFooter
              />
            </Box>
          </div>
        )
      }
    </Box>
  );
};

export default ScheduleComponent;